import TrafficChangesTrend from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficChangesTrend";

export const TRAFFIC_DIRECTION_COMMON: Record<TrafficChangesTrend, string> = {
    [TrafficChangesTrend.Grew]: "up",
    [TrafficChangesTrend.Declined]: "down",
};
